import { Button, Col, Form, List, Row, Select, Tooltip, Typography } from "antd";
import { useCallback, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import swapElements from "../../../utilities/swapElements";
import sortFields from "./sortFields";
import { isArray } from "lodash-es";

const IdentificationField = ({ handleSetConfiguration, configuration, fieldName, title, titleTooltip }) => {
  const { formatMessage } = useIntl();
  const [controlIdentificationInput, setControlIdentificationInput] = useState({
    checkField: "byes",
  });
  const [identificationList, setIdentificationList] = useState(configuration?.[fieldName] || []);

  useEffect(() => {
    const data = configuration;
    if (isArray(identificationList)) {
      data[fieldName] = identificationList;
    } else {
      data[fieldName] = [];
    }
    handleSetConfiguration(data);

    const identificationActive = Object.entries(sortFields)?.filter((item) => {
      return !identificationList?.filter((sortingItem) => item?.[0] === sortingItem?.checkField)?.length;
    })?.[0]?.[0];

    setControlIdentificationInput(() => {
      return {
        checkField: identificationActive,
      };
    });
  }, [identificationList, configuration, fieldName, handleSetConfiguration]);

  const changeSort = (value) => {
    setControlIdentificationInput((prev) => ({
      ...prev,
      checkField: value,
    }));
  };

  const handleAddSorting = () => {
    setIdentificationList((prev) => [
      ...prev,
      {
        checkField: controlIdentificationInput?.checkField,
      },
    ]);
  };

  const handleSwapItems = useCallback(
    (oldIndex, newIndex) => {
      setIdentificationList((prev) => swapElements(prev, oldIndex, newIndex));
    },
    [setIdentificationList],
  );

  const handleRemoveSortingItem = useCallback(
    (index) => {
      setIdentificationList((prev) => [...prev.filter((item, key) => key !== index)]);
    },
    [setIdentificationList],
  );

  return (
    <>
      <Row>
        <Col offset={10}>
          <Tooltip title={titleTooltip}>
            <Typography.Title level={5}>{title}</Typography.Title>
          </Tooltip>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Form.Item label={"Field to check"}>
            <Select
              showSearch={true}
              value={controlIdentificationInput?.checkField}
              onChange={(value) => changeSort(value)}
            >
              {Object.entries(sortFields)
                ?.filter((item) => {
                  return !identificationList?.filter((sortingItem) => item?.[0] === sortingItem?.checkField)?.length;
                })
                ?.map((item) => (
                  <Select.Option key={item?.[0]} value={item?.[0]}>
                    {item?.[1]}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>
          <Form.Item />
        </Col>
        <Col span={14} offset={10}>
          <Button type={"primary"} onClick={() => handleAddSorting()}>
            {formatMessage({
              id: "add",
              defaultMessage: "Add",
            })}
          </Button>
        </Col>
        <Col span={17} offset={6}>
          {identificationList?.length ? (
            <List
              size="small"
              bordered
              dataSource={identificationList}
              renderItem={(item, index) => (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <div>
                    <Button
                      onClick={() => handleSwapItems(index, index - 1)}
                      disabled={index === 0}
                      icon={<i className={"fas fa-arrow-up"} />}
                    />
                    <Button
                      onClick={() => handleSwapItems(index, index + 1)}
                      disabled={index === identificationList?.length - 1}
                      icon={<i className={"fas fa-arrow-down"} />}
                    />
                    {sortFields?.[item?.checkField]}
                  </div>
                  <Button
                    onClick={() => handleRemoveSortingItem(index)}
                    type={"text"}
                    icon={<i className={"fas fa-trash-can text-danger"} />}
                  ></Button>
                </div>
              )}
            />
          ) : (
            ""
          )}
        </Col>
      </Row>
    </>
  );
};

export default IdentificationField;
